import { render } from "./IconRfid.vue?vue&type=template&id=74d098b5"
import script from "./IconRfid.vue?vue&type=script&lang=ts"
export * from "./IconRfid.vue?vue&type=script&lang=ts"
script.render = render

export default script